import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { useLocale } from 'hooks';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';

import { SortDirection } from '../DataGrid.types';

import { useStyles } from './DataGridHeader.styles';
import { DataGridHeaderProps } from './DataGridHeader.types';

export const DataGridHeader = <T extends Record<string, unknown>>({
  columnsConfig,
  onHeaderClick,
  sortConfig,
}: DataGridHeaderProps<T>) => {
  const classes = useStyles();
  const { formatMessage } = useLocale();

  const renderSortArrow = () => {
    return sortConfig.direction === SortDirection.ASC ? (
      <ArrowUpward className={classes.icon} />
    ) : (
      <ArrowDownward className={classes.icon} />
    );
  };

  return (
    <TableHead>
      <TableRow className={classes.row}>
        {columnsConfig.map(column => (
          <TableCell
            key={column.name}
            className={classes.cell}
            data-testid="header-cell"
            onClick={() => onHeaderClick(column.name)}
          >
            <div className={classes.content}>
              {formatMessage({ id: column.labelId })}
              {column.name === sortConfig.field && renderSortArrow()}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
